/**
 * Shared LIFF formatting utilities.
 */

export const fmtBaht = (n) =>
  Number.isFinite(n)
    ? n.toLocaleString('th-TH', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    : '0.00';

export const formatDate = (dateStr) => {
  if (!dateStr) return '-';
  const d = new Date(dateStr);
  return (
    d.toLocaleDateString('th-TH', { day: '2-digit', month: 'short', year: 'numeric' }) +
    ' ' +
    d.toLocaleTimeString('th-TH', { hour: '2-digit', minute: '2-digit' })
  );
};

export const formatAddressLine = (addr) => {
  if (!addr) return '-';
  const parts = [addr.address, addr.subdistrict, addr.district, addr.province, addr.postcode].filter(Boolean);
  return parts.join(' ') || '-';
};
